export default __webpack_public_path__ + "static/media/icn_edit.88e76675.svg";